import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    leftColumn: {
        width: "100%",
    },
    numberCustomMessageWrapper: {
        display: "flex",
        alignItems: "center",
    },
    numberCustomMessageSelect: {
        "& .mantine-Input-wrapper": {
            width: "6rem",
        },
        marginRight: "0.3rem",
    },
    generateButton: {
        marginTop: "1.4rem",
        marginLeft: "-10.5rem",
    },
}))
